// extracted by mini-css-extract-plugin
module.exports = {"table":"table--5xuVf","searchBox":"searchBox--6zG8j"};